// Vue
import {Vue, Component, Prop} from 'vue-property-decorator'

// Template
import template from './template.vue'

// Components
import {Col} from '../col/Col'
import {Container} from '../container/Container'
import {Row} from '../row/Row'
import {ContentArea} from "../content_area/ContentArea";
import {Link} from "../link/Link";

interface AdditionalLink {
    text: string
    href: string
    target?: string
}

@Component({
    name: 'Footer',
    components: {
        Col,
        Container,
        Row,
        ContentArea,
        Link
    },
    mixins: [
        template,
    ]
})
export class Footer extends Vue {

    public elements: any[] = []

    @Prop({default: null})
    public copyrightText!: string | null

    @Prop({default: () => ([])})
    public additionalLinksBefore!: AdditionalLink[]

    @Prop({default: () => ([])})
    public additionalLinksAfter!: AdditionalLink[]

    @Prop({default: true})
    public withCookieLayer!: boolean

    public created () {

    }

    get currentYear() {
        return new Date().getFullYear()
    }

    get finalCopyrightText() {
        if (this.copyrightText) {
            return this.copyrightText
        } else {
            return (this as any).$t('COPYRIGHT_DAIMLER')
        }
    }
}